import React from 'react';
import { StanButton, StanDropdown, StanInput } from '@/components';
import { useTextFilter } from '../hooks/useTextFilter';
import { useFloatingFilterMenu } from '../hooks/useFloatingFilterMenu';
import { BaseFilter, BaseFilterProps } from '../components/BaseFilter';
import styles from '../StanFilters.module.css';

type Props = BaseFilterProps;

/**
 * Text filter component for filtering text-based fields
 * Supports contains and equals operators with user input
 */
const TextFilter: React.FC<Props> = ({ id, label, filterItem, onApply, onClearFilter, disabled, placement }) => {
    const { menuRef, triggerProps, isOpen, handleOpenChange, closeMenu } = useFloatingFilterMenu(disabled);

    const {
        summary,
        hasSummary,
        operatorOptions,
        currentOperator,
        value,
        apply,
        clearFilters,
        // Extracted complex logic from hook
        handleInputChange,
        handleOperatorChange,
    } = useTextFilter({
        filterItem,
        onApply,
        onClearFilter,
        disabled,
        closeMenu,
    });

    return (
        <BaseFilter
            id={id}
            label={label}
            filterItem={filterItem}
            onApply={onApply}
            onClearFilter={onClearFilter}
            disabled={disabled}
            placement={placement}
            menuRef={menuRef}
            triggerProps={triggerProps}
            summary={summary}
            hasSummary={hasSummary}
            isOpen={isOpen}
            handleOpenChange={handleOpenChange}
            clearFilters={clearFilters}
        >
            <div className={styles.formVertical}>
                <StanDropdown
                    id={`${id}-text-operator-dropdown`}
                    name='text-operator'
                    options={operatorOptions}
                    onSelect={val => handleOperatorChange(val.value)}
                    currentValue={currentOperator}
                />
                <StanInput
                    name='text-filter'
                    type='text'
                    value={value}
                    onChange={handleInputChange}
                    placeholder='Enter text'
                />
                <div className='pt-2'>
                    <StanButton type='button' className={styles.applyButton} onClick={apply} name='apply-text-filter'>
                        <span>Apply</span>
                    </StanButton>
                </div>
            </div>
        </BaseFilter>
    );
};

export default TextFilter;
